import { Css } from "src/Css";

/** Class name anchor for the small-size shrink transform override. */
export const smallShrinkLabel = "smallShrinkLabel";

export const css = {
  /** When the label is shrunk at small size, use a slightly larger scale than MUI's default. */
  [`.${smallShrinkLabel}.MuiInputLabel-shrink`]: Css.add("transform", "translate(0, 1.5px) scale(0.9)").$,
};
